import ROUTE_NAMES from "routes/routeNames";
import DASHBOARD_ICON from "assets/images/dashboard_icon.png";
import CMS from "../../assets/images/content_management_icon.png";
import CONGREGATION from "../../assets/images/category_management_icon.png";

const SIDE_BAR_ITEMS = [
  {
    id: "dashboard",
    title: "Users",
    imgURL: DASHBOARD_ICON,
    url: ROUTE_NAMES.MAIN_ROUTES.DASHBOARD,
  },
  {
    id: "cms",
    title: "CMS",
    imgURL: CMS,
    url: ROUTE_NAMES.MAIN_ROUTES.CMS,
  },
  {
    id: "congregations",
    title: "Congregations",
    imgURL: CONGREGATION,
    url: ROUTE_NAMES.MAIN_ROUTES.CONGREGATIONS,
  },
  {
    id: "RequestCongregations",
    title: "Requested Congregations",
    imgURL: CONGREGATION,
    url: ROUTE_NAMES.MAIN_ROUTES.REQUESTED_CONGREGATION,
  },
];

export default SIDE_BAR_ITEMS;
